module.exports = __webpack_public_path__ + "static/img/presents.d37cf60d.png";